<div class="main-content" >
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div>

                    <div class="text-right">
                        <i class="material-icons">add</i>
                    </div>
                    <div class="container-fluid">
                        <div class="table-responsive">
                            <table id="table" class="table table-striped " cellspacing="0" width="100%">
                                <thead>
                                    <tr>
                                        <!--<th>Niche</th>-->
                                        <th>Version number</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!--*ngFor="let row of data; let i = index"-->
                                    <tr>
                                        <!--<td>General</td>-->
                                        <td>2.0</td>
                                        <td><i class="material-icons">edit</i><i class="material-icons">delete</i></td>
                                    </tr>
                                    <tr>
                                        <!--<td>General</td>-->
                                        <td>2.0</td>
                                        <td><i class="material-icons">edit</i><i class="material-icons">delete</i></td>
                                    </tr>
                                    <tr>
                                        <!--<td>Sports</td>-->
                                        <td>2.0</td>
                                        <td><i class="material-icons">edit</i><i class="material-icons">delete</i></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
